// extracted by mini-css-extract-plugin
export default {"main":"preswrite_main__fTaM6","title":"preswrite_title__XE0hS"};